import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Constant } from '../common/constant'; // Replace with your actual API base URL


@Injectable({
  providedIn: 'root'
})
export class SelfCheckInService {
  private apiUrl = Constant.BASE_URL; // Replace with your actual API base URL

  constructor(private http: HttpClient) {}

  generateUniversalQr(accountId: number): Observable<string> {
    const params = new HttpParams().set('accountId', String(accountId));
    return this.http.post(`${this.apiUrl}/api/self-check-in/generate-universal`, null, { params, responseType: 'text' });
  }

  generateNonUniversalQr(details: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/api/self-check-in/generate-non-universal`, details, { responseType: 'text' });
  }

  validateDevice(deviceId: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/api/self-check-in/validate/${deviceId}`);
  }

  searchHost(accountId: number, searchTerm: string): Observable<any> {
    const params = new HttpParams()
      .set('accountId', String(accountId))
      .set('searchTerm', searchTerm);
    return this.http.get(`${this.apiUrl}/api/self-check-in/search-host`, { params });
  }

  getAllHosts(accountId: number): Observable<any> {
    const params = new HttpParams().set('accountId', String(accountId));
    return this.http.get(`${this.apiUrl}/api/self-check-in/hosts`, { params });
  }

  submitSelfCheckIn(details: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/api/self-check-in/submit`, details);
  }

  getStatus(selfGuestId: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/api/self-check-in/status/${selfGuestId}`);
  }
}
